import { makeStyles } from '@material-ui/styles';
import cn from 'clsx';

import { Text, TimeLine } from '@bizzabo/design-system';

interface TimeInfoProps {
    isDisabled?: boolean;
}

const TimeInfo: React.FC<TimeInfoProps> = ({ isDisabled, children }) => {
    const classes = useStyles();

    return (
        <Text variant="t81" className={cn(classes.timeInfo, { [classes.disabled]: isDisabled })}>
            <TimeLine className={classes.timeIcon} title="timeLine" />
            {children}
        </Text>
    );
};

const useStyles = makeStyles(
    () => ({
        timeInfo: {
            display: 'flex',
            alignItems: 'center',
            flexWrap: 'wrap',
            lineHeight: 1,
            marginBottom: 10,
        },
        timeIcon: {
            marginRight: 4,
            fontSize: 17,
        },
        disabled: {
            opacity: 0.6,
        },
    }),
    { classNamePrefix: 'meetings-time-info' }
);

export default TimeInfo;
